import { observer } from "mobx-react-lite";
import { useState, useRef } from "react";

let mouseOffset = 0;
let startX = 0;

const ImageCompareStack = ({ beforeImg, afterImg }) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(50); // 显示 AI 图的宽度百分比

  const onMouseMove = (e) => {
    e.preventDefault();
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const offsetX = e.clientX - mouseOffset + 22 - rect.left;
    let newWidth = (offsetX / rect.width) * 100;
    newWidth = Math.max(0, Math.min(100, newWidth));
    setWidth(newWidth);
  };

  const onMouseDown = (e) => {
    startX = e.clientX;
    const rect = e.target.getBoundingClientRect();
    mouseOffset = startX - rect.left;

    document.body.style.cursor = "ew-resize";
    document.body.addEventListener("mousemove", onMouseMove);
    document.body.addEventListener(
      "mouseup",
      () => {
        document.body.style.cursor = "default";
        document.body.removeEventListener("mousemove", onMouseMove);
      },
      { once: true }
    );
  };

  return (
    <div className="absolute inset-0 overflow-hidden" ref={containerRef}>
      {/* 底层：原图，始终完整显示 */}
      <img
        src={afterImg}
        className="absolute inset-0 w-full h-full object-cover"
        alt="结果图"
        draggable={false}
      />

      {/* 按钮 */}
      <div
        className="absolute right-10px top-10px flex items-center justify-center h-26px w-60px text-14px rounded-6px text-white user-select-none"
        style={{
          background:
            "linear-gradient(90deg, #7774FF 2.49%, #017FFD 53.28%, #01B1FD 98.48%)",
        }}
      >
        AI生成
      </div>
      {/* 上层：AI生成图，宽度受控 */}
      <div
        className="absolute top-0 left-0 h-full overflow-hidden"
        style={{ width: `${width}%` }}
      >
        <img
          src={beforeImg}
          className="object-left w-full h-full object-cover"
          alt="原图"
          draggable={false}
        />
        <div
          className="absolute left-10px top-10px flex items-center justify-center h-26px w-60px text-14px rounded-6px text-white bg-[rgba(0,0,0,0.30)] backdrop-blur user-select-none"
        >
          原图
        </div>
      </div>

      {/* 滑块控制器 */}
      <div
        className="bounce-in-left absolute top-0 bottom-0 w-48px cursor-ew-resize transform -translate-x-[50%]"
        style={{ left: `${width}%` }}
        onMouseDown={onMouseDown}
      >
        <div className="absolute left-[50%] transform -translate-x-[50%] w-4px bg-white h-full"></div>
        <img
          src="https://p4.ssl.qhimg.com/t110b9a93010e1c3307878c8405.png"
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 size-48px select-none cursor-"
          draggable={false}
        />
      </div>


    </div>
  );
};

export default observer(ImageCompareStack);
